module.exports = __webpack_public_path__ + "static/media/drake_img_3.576e2463.png";